import { useEffect, useState } from "react";

export const TypewriterText: React.FC<{
  text: string;
  className?: string;
  startDelayMs?: number;
  charIntervalMs?: number;
}> = ({ text, className = "", startDelayMs = 0, charIntervalMs = 60 }) => {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    let i = 0;
    let intervalId: number | null = null;
    const startTimeout = window.setTimeout(() => {
      intervalId = window.setInterval(() => {
        i += 1;
        setDisplayed(text.slice(0, i));
        if (i >= text.length && intervalId !== null) {
          window.clearInterval(intervalId);
        }
      }, charIntervalMs);
    }, startDelayMs);

    return () => {
      window.clearTimeout(startTimeout);
      if (intervalId !== null) {
        window.clearInterval(intervalId);
      }
    };
  }, [text, startDelayMs, charIntervalMs]);

  return <p className={className}>{displayed}</p>;
};
